import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import Button from "react-bootstrap-button-loader";
import Select from "react-select";
import { Modal, Tabs, Tab } from "react-bootstrap";
import {
  BASE_IMAGES_URL,
  itemCount,
  COMMON_FAIL_MESSAGE,
  validateOnlyNums,
} from "Constants";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { showError, showSuccess } from "ReduxErrorBar";
import { fetchAllUnpublishedCourses } from "CourseAction";
import {
  handleLessonModal,
  textAttachmentData,
  documentAttachmentData,
  videoAttachmentData,
  audioAttachmentData,
  linkAttachmentData,
  saveChapter,
  saveLesson,
  editLesson,
  saveLessonAttachment,
} from "CourseAction";
import ImageCropper from "ImageCropper";
import VideoFilesDrop from "../common/lesson-video-uploader";
import AudioFilesDrop from "../common/lesson-audio-uploader";
import DocumentFilesDrop from "../common/lesson-file-uploader";
import RichTextTinymceEditor from "RichTextTinymceEditor";
import LocaleStrings from "Languages";

const scrollStyle = { maxHeight: 350, overflowY: "auto" };

class AddLesson extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, selectedTab: 1 };
  }

  componentDidMount() {}

  closeModal = () => {
    this.setState({ loading: false, selectedTab: 1 });
    this.props.editLesson({});
    this.props.handleLessonModal({ showModal: false });

    let textAttachment = [
      { key: "text", fixed: true, value: "", field: "new", attid: "" },
    ];
    let documentAttachment = [
      {
        key: "document",
        fixed: true,
        file: "",
        filename: "",
        field: "new",
        attid: "",
      },
    ];
    let videoAttachment = [
      {
        key: "video",
        fixed: true,
        file: "",
        filename: "",
        thumbnail: "",
        field: "new",
        attid: "",
      },
    ];
    let audioAttachment = [
      {
        key: "audio",
        fixed: true,
        file: "",
        filename: "",
        field: "new",
        attid: "",
      },
    ];
    let linkAttachment = [
      { key: "link", fixed: true, value: "", field: "new", attid: "" },
    ];

    this.props.textAttachmentData(textAttachment);
    this.props.documentAttachmentData(documentAttachment);
    this.props.videoAttachmentData(videoAttachment);
    this.props.audioAttachmentData(audioAttachment);
    this.props.linkAttachmentData(linkAttachment);
  };

  afterSubmit = (courseid) => {
    let { session } = this.props;

    this.props.finishOperationsCallback();
    this.props.fetchAllUnpublishedCourses(session, courseid);
    this.closeModal();
  };

  onSubmitForm = (data) => {
    let {
      session,
      editMode,
      initialValues,
      lessonTextAttachment,
      lessonLinkAttachment,
      lessonDocumentAttachment,
      lessonVideoAttachment,
      lessonAudioAttachment,
      chapters,
      chapterLessons,
    } = this.props;
    var courseid = initialValues.courseid;
    var chapterid = initialValues.chapterid ? initialValues.chapterid : null;

    var values = { ...data };
    if (data.quizid) {
      if (data.quizid != "" && data.quizid.value && data.quizid.value != "") {
        values.quizid = data.quizid.value;
      } else if (data.tagid != "" && !Array.isArray(data.tagid)) {
        values.quizid = data.quizid;
      }
    }

    // Check attachment files
    if (lessonTextAttachment && lessonTextAttachment.length > 0) {
      lessonTextAttachment = _.filter(lessonTextAttachment, (obj) => {
        return obj.value != "";
      });
    }
    if (lessonLinkAttachment && lessonLinkAttachment.length > 0) {
      lessonLinkAttachment = _.filter(lessonLinkAttachment, (obj) => {
        return obj.value != "";
      });
    }
    if (lessonDocumentAttachment && lessonDocumentAttachment.length > 0) {
      lessonDocumentAttachment = _.filter(lessonDocumentAttachment, (obj) => {
        return obj.file != "";
      });
    }
    if (lessonVideoAttachment && lessonVideoAttachment.length > 0) {
      lessonVideoAttachment = _.filter(lessonVideoAttachment, (obj) => {
        return obj.file != "";
      });
    }
    if (lessonAudioAttachment && lessonAudioAttachment.length > 0) {
      lessonAudioAttachment = _.filter(lessonAudioAttachment, (obj) => {
        return obj.file != "";
      });
    }

    var attachmentsArr = [
      ...lessonTextAttachment,
      ...lessonLinkAttachment,
      ...lessonDocumentAttachment,
      ...lessonVideoAttachment,
      ...lessonAudioAttachment,
    ];
    var parentInfo = { courseid: courseid, chapterid: chapterid };

    let isNewChapter = values.chaptername ? values.chaptername : "";

    this.setState({ loading: true });
    if (isNewChapter != "") {
      // New lesson with new chapter
      let chapterVal = {
        chaptername: isNewChapter,
        eventid: session.eventid,
        courseid: initialValues.courseid,
      };
      if (!editMode) {
        chapterVal.ranking = chapters.length + 1;
      }

      this.props.saveChapter(session, chapterVal, (res) => {
        if (res.success) {
          values.chapterid = res.data.resource[0].chapterid;
          this.props.saveLesson(session, values, (responose) => {
            if (responose.success) {
              if (attachmentsArr.length > 0) {
                parentInfo.lessonid = responose.data.resource[0].lessonid;
                parentInfo.chapterid = values.chapterid;

                this.props.saveLessonAttachment(
                  session,
                  parentInfo,
                  attachmentsArr,
                  (respo) => {
                    this.setState({ loading: false });
                    if (respo.success) {
                      this.afterSubmit(courseid);
                      // this.props.fetchAllUnpublishedCourses(session, courseid);
                      // this.closeModal();

                      if (editMode) {
                        this.props.showSuccess(
                          LocaleStrings.course_lesson_form_update_success
                        );
                      } else {
                        this.props.showSuccess(
                          LocaleStrings.course_lesson_form_added_with_chapter_success
                        );
                      }
                    } else {
                      this.props.showError(COMMON_FAIL_MESSAGE);
                    }
                  }
                );
              } else {
                this.afterSubmit(courseid);
                // this.props.fetchAllUnpublishedCourses(session, courseid);
                // this.closeModal();
                if (editMode) {
                  this.props.showSuccess(
                    LocaleStrings.course_lesson_form_update_success
                  );
                } else {
                  this.props.showSuccess(
                    LocaleStrings.course_lesson_form_added_with_chapter_success
                  );
                }
              }
            } else {
              this.props.showError(COMMON_FAIL_MESSAGE);
            }
          });
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      });
    } else {
      // New lesson under old chapter
      if (!editMode) {
        values.ranking = chapterLessons.length + 1;
      }
      this.props.saveLesson(session, values, (responose) => {
        if (responose.success) {
          if (attachmentsArr.length > 0) {
            parentInfo.lessonid = responose.data.resource[0].lessonid;

            this.props.saveLessonAttachment(
              session,
              parentInfo,
              attachmentsArr,
              (respo) => {
                this.setState({ loading: false });
                if (respo.success) {
                  this.afterSubmit(courseid);
                  // this.props.fetchAllUnpublishedCourses(session, courseid);
                  // this.closeModal();

                  if (editMode) {
                    this.props.showSuccess(
                      LocaleStrings.course_lesson_form_update_success
                    );
                  } else {
                    this.props.showSuccess(
                      LocaleStrings.course_lesson_form_added_under_chapter_success
                    );
                  }
                } else {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                }
              }
            );
          } else {
            this.afterSubmit(courseid);
            // this.props.fetchAllUnpublishedCourses(session, courseid);
            // this.closeModal();
            if (editMode) {
              this.props.showSuccess(
                LocaleStrings.course_lesson_form_update_success
              );
            } else {
              this.props.showSuccess(
                LocaleStrings.course_lesson_form_added_with_chapter_success
              );
            }
          }
        } else {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      });
    }
  };

  handleSelect = (key) => {
    this.setState({ selectedTab: key });
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      courseLessonModal,
      initialValues,
      editMode,
    } = this.props;
    let { selectedTab } = this.state;

    return (
      <div>
        <Modal
          className="modal-container"
          show={
            courseLessonModal && courseLessonModal.showModal === true
              ? true
              : false
          }
          animation={true}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {editMode
                ? LocaleStrings.course_lesson_text_update_lesson
                : LocaleStrings.course_lesson_text_add_lesson}

              {courseLessonModal &&
              courseLessonModal.lessonType === "old-chapter" ? (
                <span className="theme-color-text p-5">
                  / {courseLessonModal.chapteData.chaptername}
                </span>
              ) : (
                ""
              )}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.onSubmitForm)}>
            <Modal.Body>
              <div className="add-lesson-container">
                <AddLessonForm {...this.props} />
              </div>
              <div className="hr-custom">
                <label
                  className="control-label-top theme-color-text"
                  style={{ fontWeight: 500 }}
                >
                  {LocaleStrings.course_lesson_text_private_section}
                </label>
              </div>
              <div>
                {/* <label className="control-label-top">{LocaleStrings.course_lesson_text_lesson_attachment}</label> */}

                <ContentAudio {...this.props} />
                <ContentText {...this.props} />
                <ContentDocument {...this.props} />
                <ContentLinks {...this.props} />
                <ContentQuiz {...this.props} />

                {/* <Tabs className="branding-tabs mt-0" id="lesson-from-tab" activeKey={selectedTab} onSelect={this.handleSelect}>
                                    <Tab className="pt-15" eventKey={1} title={LocaleStrings.course_lesson_text_lesson_attachment_type1}>
                                        <ContentText {...this.props}/>
                                    </Tab>
                                    <Tab className="pt-15" eventKey={2} title={LocaleStrings.course_lesson_text_lesson_attachment_type2}>
                                        <ContentDocument {...this.props}/>
                                    </Tab>
                                    <Tab className="pt-15" eventKey={3} title={LocaleStrings.course_lesson_text_lesson_attachment_type3}>
                                        <ContentVideo {...this.props}/>
                                    </Tab>
                                    <Tab className="pt-15" eventKey={4} title={LocaleStrings.course_lesson_text_lesson_attachment_type4}>
                                        <ContentAudio {...this.props}/>
                                    </Tab>
                                    <Tab className="pt-15" eventKey={5} title={LocaleStrings.course_lesson_text_lesson_attachment_type5}>
                                        <ContentLinks {...this.props}/>
                                    </Tab>
                                </Tabs> */}
              </div>
              <div>
                <LessonSettingsForm {...this.props} />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-white"
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                className="btn btn-custom-blue ml-10"
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.button_save}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let edit = !_.isEmpty(state.editLessonData);
  var initVals = { videotype: "video" };

  if (edit) {
    initVals = state.editLessonData;
    initVals.coverimagehidden = state.editLessonData.coverimage;

    if (state.lessonTextAttachment.length > 0) {
      let data = [];
      _.map(state.lessonTextAttachment, (item, index) => {
        data.push(item.value);
      });
      initVals.content_text = data;
    }

    if (state.lessonLinkAttachment.length > 0) {
      let data = [];
      _.map(state.lessonLinkAttachment, (item, index) => {
        data.push(item.value);
      });
      initVals.content_link = data;
    }
  } else {
    if (state.courseLessonModal && state.courseLessonModal.chapteData) {
      initVals.chapterid = state.courseLessonModal.chapteData.chapterid;
    }

    if (
      state.allUnpublishedCourseList &&
      state.allUnpublishedCourseList.count > 0
    ) {
      initVals.courseid = state.allUnpublishedCourseList.resource[0].courseid;
    }
  }

  // Fetching chapter's lessons
  let chapterLessons = [];
  let chapters = [];
  if (
    state.allUnpublishedCourseList &&
    state.allUnpublishedCourseList.count > 0
  ) {
    chapters =
      state.allUnpublishedCourseList.resource[0].course_chapter_by_courseid;
    let lessons =
      state.allUnpublishedCourseList.resource[0].course_lessons_by_courseid;
    let getLessons = _.filter(lessons, (obj) => {
      return obj.chapterid === initVals.chapterid;
    });
    chapterLessons = _.sortBy(getLessons, ["ranking", "createdon"]);
  }

  return {
    session: state.session,
    editMode: edit,
    initialValues: initVals,
    allSpeakers: state.allSpeakers,
    quizList: state.quizList,
    courseLessonModal: state.courseLessonModal,
    lessonTextAttachment: state.lessonTextAttachment,
    lessonDocumentAttachment: state.lessonDocumentAttachment,
    lessonVideoAttachment: state.lessonVideoAttachment,
    lessonAudioAttachment: state.lessonAudioAttachment,
    lessonLinkAttachment: state.lessonLinkAttachment,
    allUnpublishedCourseList: state.allUnpublishedCourseList,
    chapters,
    chapterLessons,
  };
}

function validate(values, ownProps) {
  var errors = {};
  var lessontitle = values["lessontitle"];
  var chaptername = values["chaptername"];
  var shortdescription = values["shortdescription"];
  var videotype = values["videotype"];
  var covervideo = values["covervideo"];
  var duration = values["duration"];
  var coverimagehidden = values["coverimagehidden"];

  if (!coverimagehidden || coverimagehidden == "") {
    errors["coverimagehidden"] = LocaleStrings.course_form_validation_required;
  }

  if (!lessontitle || lessontitle.trim() === "") {
    errors["lessontitle"] = LocaleStrings.course_form_validation_required;
  } else if (
    lessontitle &&
    lessontitle != ownProps.initialValues.lessontitle &&
    _.filter(ownProps.chapterLessons, (obj) => {
      return obj.lessontitle === lessontitle;
    }).length > 0
  ) {
    errors["lessontitle"] =
      LocaleStrings.course_lesson_form_validation_lesson_already_exist;
  }

  if (
    ownProps.courseLessonModal &&
    ownProps.courseLessonModal.lessonType === "new-chapter" &&
    (!chaptername || chaptername.trim() === "")
  ) {
    errors["chaptername"] = LocaleStrings.course_form_validation_required;
  } else if (
    ownProps.courseLessonModal &&
    ownProps.courseLessonModal.lessonType === "new-chapter" &&
    chaptername &&
    _.filter(ownProps.chapters, (obj) => {
      return obj.chaptername === chaptername;
    }).length > 0
  ) {
    errors["chaptername"] =
      LocaleStrings.course_chapter_form_validation_chapter_already_exist;
  }
  if (!shortdescription || shortdescription.trim() === "") {
    errors["shortdescription"] = LocaleStrings.course_form_validation_required;
  }
  if (videotype === "link" && (!covervideo || covervideo.trim() === "")) {
    errors["covervideo"] = LocaleStrings.course_form_validation_required;
  }

  if (!duration || !validateOnlyNums(duration) || duration < 0) {
    errors["duration"] =
      LocaleStrings.course_lesson_form_validation_lesson_duration_min;
  }
  if (duration && (!validateOnlyNums(duration) || duration < 0)) {
    errors["duration"] =
      LocaleStrings.course_lesson_form_validation_lesson_duration_min;
  }
  return errors;
}

export default connect(mapStateToProps, {
  handleLessonModal,
  textAttachmentData,
  documentAttachmentData,
  videoAttachmentData,
  audioAttachmentData,
  linkAttachmentData,
  saveChapter,
  saveLesson,
  editLesson,
  saveLessonAttachment,
  fetchAllUnpublishedCourses,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "LessonForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AddLesson)
);

class AddLessonForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      imagePreviewUrl: "",
      videoData: {},
      videoType: props.initialValues.videotype,
    };

    if (props.editMode) {
      if (props.initialValues.coverimage && props.initialValues.covervideo) {
        let file = props.initialValues.covervideo;
        var original = file.split("/").pop();
        var fileName = original;
        var fileObj = { file: file, filename: fileName };

        this.state = {
          imagePreviewUrl: `${BASE_IMAGES_URL}/${props.initialValues.coverimage}?api_key=${props.session.apiKey}&session_token=${props.session.sessionToken}`,
          videoData: fileObj,
        };
      } else if (
        props.initialValues.coverimage &&
        !props.initialValues.covervideo
      ) {
        this.state = {
          imagePreviewUrl: `${BASE_IMAGES_URL}/${props.initialValues.coverimage}?api_key=${props.session.apiKey}&session_token=${props.session.sessionToken}`,
          videoData: {},
        };
      } else if (
        !props.initialValues.coverimage &&
        props.initialValues.covervideo
      ) {
        let file = props.initialValues.covervideo;
        var original = file.split("/").pop();
        var fileName = original;
        var fileObj = { file: file, filename: fileName };

        this.state = {
          imagePreviewUrl: "",
          videoData: fileObj,
        };
      }
    }
  }

  componentDidMount() {
    if (this.props.editMode) {
      this.setState({ videoType: this.props.initialValues.videotype });
    }
  }

  onImageSave = (img) => {
    this.setState({ imagePreviewUrl: img });
    this.props.autofill("coverimagehidden", img);
  };

  onImageChange = (imageAvailable) => {};

  onFilesDrop = (data) => {
    this.setState({ videoData: data });
    this.props.autofill("covervideohidden", data);
  };

  onFileAvailable = (changed) => {};

  handleVideoType = (e) => {
    var type = e.target.value;
    var { editMode } = this.props;

    if (!editMode)
      if (type === "link") {
        this.props.autofill("covervideohidden", "");
        this.setState({ videoData: {} });
      } else {
        this.props.autofill("covervideo", "");
      }

    this.setState({ videoType: type });
  };

  render() {
    let { session, courseLessonModal, editMode, initialValues } = this.props;
    let { imagePreviewUrl, videoData, videoType } = this.state;

    let fileOld = true;
    let filePreview = "";
    let fileName = "";
    if (videoData && videoData.file) {
      var file = videoData.file;
      fileName = videoData.filename;
      filePreview = `${BASE_IMAGES_URL}/${file}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
      fileOld = true;
      var n = file.search(";base64,");
      if (n > 0) {
        fileOld = false;
        filePreview = file;
      }
    }

    return (
      <div className="basicform">
        {courseLessonModal && courseLessonModal.lessonType === "new-chapter" ? (
          <Field
            name="chaptername"
            label={LocaleStrings.course_lesson_form_label_chapter_name}
            placeholder={LocaleStrings.course_lesson_form_ph_chapter_name}
            type="text"
            component={this.renderFieldText}
            mandatory="true"
            labelposition={LABEL_POSITION_TOP}
          />
        ) : (
          // <div className="form-group row">
          //   <label className="control-label-top col-sm-12">
          //     {LocaleStrings.course_lesson_form_label_chapter_name}
          //     <span className="label-mandatory">*</span>
          //   </label>
          //   <div
          //     className="col-sm-12 col-sm-offset-0 theme-color-text"
          //     style={{
          //       padding: "6px 14px",
          //       fontWeight: "bold",
          //     }}
          //   >
          //     {courseLessonModal.chapteData.chaptername}
          //   </div>
          // </div>
          ""
        )}
        <div className="row form-group">
          <div className="col-md-12">
            <label className="control-label-top">
              {LocaleStrings.course_lesson_form_label_lesson_cover_image}
              <span className="label-mandatory">*</span>
            </label>
            <ImageCropper
              displaySize={{ width: 540, height: 270 }} // For image display style
              requiredSize={{ width: 540, height: 270 }} // For image size required validation
              cropperSize={{ width: 380, height: 190 }} // Cropper display size. Note its add 50px for padding
              border={10}
              onImageSave={this.onImageSave}
              onImageChange={this.onImageChange}
              imagepath={imagePreviewUrl}
              imageType="jpg"
              className="drop-zone-area-custom-image pointer"
              insideImage="../../style/images/dummy-image-fill@3x.png"
              insideImageStyle={{
                width: 50,
                height: 50,
              }}
              insideText="Drag and Drop or Click here to upload image. Image size must be 540x270 px."
            />
            <Field
              name="coverimagehidden"
              type="text"
              component={this.renderHiddenFieldText}
              bsClass="mt-15"
            />
          </div>
        </div>
        <div className="row form-group">
          <div className="col-sm-12">
            <div className="d-flex">
              <Field
                onChange={this.handleVideoType}
                name="videotype"
                label={
                  LocaleStrings.course_lesson_form_course_lesson_videotype_option1
                }
                component={this.renderFieldRadio}
                type="radio"
                value="video"
              />{" "}
              <Field
                onChange={this.handleVideoType}
                name="videotype"
                label={
                  LocaleStrings.course_lesson_form_course_lesson_videotype_option2
                }
                component={this.renderFieldRadio}
                type="radio"
                value="link"
              />
            </div>
          </div>
        </div>
        {videoType === "video" ? (
          <div className="form-group row">
            <div className="col-md-12">
              <label className="control-label-top">
                {LocaleStrings.course_lesson_form_label_lesson_cover_video}
              </label>
              <VideoFilesDrop
                onFileSave={this.onFilesDrop}
                onFileChnageLocally={this.onFileAvailable}
                filepath={filePreview}
                fileName={fileName}
                fileOld={fileOld}
                className="lesson-video-dropbox"
              />
              <Field
                name="covervideohidden"
                label=""
                placeholder=""
                type="text"
                component={this.renderHiddenFieldText}
              />
            </div>
          </div>
        ) : (
          <Field
            name="covervideo"
            label={LocaleStrings.course_lesson_form_label_lesson_cover_link}
            placeholder={LocaleStrings.course_lesson_form_ph_lesson_cover_link}
            type="text"
            component={this.renderFieldText}
            mandatory="false"
            labelposition={LABEL_POSITION_TOP}
          />
        )}
        <Field
          name="lessontitle"
          label={LocaleStrings.course_lesson_form_label_lesson_name}
          placeholder={LocaleStrings.course_lesson_form_ph_lesson_duration}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="duration"
          label={LocaleStrings.course_lesson_form_label_lesson_duration}
          placeholder={LocaleStrings.course_lesson_form_ph_lesson_name}
          type="number"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="shortdescription"
          label={LocaleStrings.course_lesson_form_label_short_desc}
          placeholder={LocaleStrings.course_lesson_form_ph_short_desc}
          component={this.renderFieldTextarea}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />
      </div>
    );
  }
}

class ContentText extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { show: false };
  }

  renderCustomRichTextareaTinymce(field) {
    return <RichTextTinymceEditor type={field.type} {...field} />;
  }

  handleTextChanges = (index, e) => {
    let value = e;

    let { lessonTextAttachment } = this.props;
    let atthArray = lessonTextAttachment;

    atthArray[index].value = value;

    this.props.textAttachmentData(atthArray);
    // this.props.autofill(`content_text[${index}]`, value);
  };

  handleAttachmentArray = (action, index) => {
    let { lessonTextAttachment } = this.props;
    let atthArray = lessonTextAttachment;

    if (action === "add") {
      var obj = {
        key: "text",
        fixed: false,
        value: "",
        field: "new",
        attid: "",
      };
      atthArray.push(obj);
    } else {
      _.pullAt(atthArray, index);
      this.props.autofill(`content_text[${index}]`, "");
    }

    this.props.textAttachmentData(atthArray);
  };

  handleShowHide = () => {
    this.setState({ show: !this.state.show });
  };

  renderAttachment = () => {
    let { lessonTextAttachment } = this.props;
    let attachmentArray = lessonTextAttachment;

    return _.map(attachmentArray, (item, index) => {
      return (
        <Field
          key={`key-${index}`}
          name={`content_text[${index}]`}
          type="minimal"
          component={this.renderCustomRichTextareaTinymce}
          height={200}
          onChange={this.handleTextChanges.bind(this, index)}
        />
      );
    });
  };

  render() {
    let { show } = this.state;
    let faIcon = show ? "fa fa-caret-right" : "fa fa-caret-down";

    return (
      // <div className="row">
      //     <label className="control-label-top">{LocaleStrings.course_lesson_attachment_form_label_content_text}</label>

      //     {this.renderAttachment()}
      // </div>

      <div className="form-group row">
        <div className="col-md-12">
          <label
            onClick={this.handleShowHide}
            className="control-label-top pointer"
            style={{ fontWeight: 500 }}
          >
            <i className={`pointer ${faIcon}`} aria-hidden="true"></i>
            &ensp;
            {LocaleStrings.course_lesson_attachment_form_label_content_text}
          </label>
        </div>

        <div className="col-md-12">
          <div className="pl-12">{show ? this.renderAttachment() : ""}</div>
        </div>
      </div>
    );
  }
}

class ContentDocument extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { show: false };
  }

  onFilesDrop = (index, files) => {
    let { lessonDocumentAttachment } = this.props;
    let atthArray = lessonDocumentAttachment;
    let length = lessonDocumentAttachment.length;

    if (
      length === 1 &&
      lessonDocumentAttachment[0].file === "" &&
      lessonDocumentAttachment[0].filename === ""
    ) {
      atthArray[0].file = files.file ? files.file : "";
      atthArray[0].filename = files.filename ? files.filename : "";
    } else {
      var data = {
        key: "document",
        fixed: false,
        file: files.file,
        filename: files.filename ? files.filename : "",
        field: "new",
        attid: "",
      };
      atthArray.push(data);
    }

    this.props.documentAttachmentData(atthArray);
    this.props.autofill(`content_document[${length - 1}]`, files);
  };

  onFileAvailable = (available) => {};

  handleAttachmentArray = (action, index) => {
    let { lessonDocumentAttachment } = this.props;
    let atthArray = lessonDocumentAttachment;
    let length = lessonDocumentAttachment.length;

    if (action === "add") {
      var obj = {
        key: "document",
        fixed: false,
        file: "",
        filename: "",
        field: "new",
        attid: "",
      };
      atthArray.push(obj);
    } else {
      if (length === 1) {
        atthArray[0].file = "";
        atthArray[0].filename = "";
        atthArray[0].fixed = true;
      } else {
        _.pullAt(atthArray, index);
        if (index === 0) {
          atthArray[0].fixed = true;
        }
        this.props.autofill(`content_document[${index}]`, "");
      }
    }

    this.props.documentAttachmentData(atthArray);
  };

  handleShowHide = () => {
    this.setState({ show: !this.state.show });
  };

  renderAttachment = () => {
    let { lessonDocumentAttachment } = this.props;
    let attachmentArray = lessonDocumentAttachment;

    return _.map(attachmentArray, (item, index) => {
      var filePreview = "";
      var fileName = "";
      var fileOld = true;

      if (item && item.file) {
        var file = item.file;
        fileName = item.filename;
        filePreview = `${BASE_IMAGES_URL}/${file}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
        fileOld = true;
        var n = file.search(";base64,");
        if (n > 0) {
          fileOld = false;
          filePreview = item.file;
        }
      }
      let icon = "../../style/images/file_document.svg";
      if (fileName != "") {
        var fileType = fileName.split(".").pop();

        if (
          fileType === "svg" ||
          fileType === "png" ||
          fileType === "jpg" ||
          fileType === "jpeg"
        ) {
          icon = "../../style/images/file_image.svg";
        }
      }

      return (
        <div key={`key-${index}`} className="pb-5">
          <div className={`lesson-document-displaybox`}>
            <img className="file-icon" src={`${icon}`} alt="" />
            <span>
              <div className="custom-text1">{fileName}</div>
            </span>
            <img
              onClick={() => this.handleAttachmentArray("remove", index)}
              className="file-delete-button"
              src="../../style/images/trash_icon_xs.png"
              alt=""
            />
          </div>
          <Field
            name={`content_document[${index}]`}
            label=""
            placeholder=""
            type="text"
            component={this.renderHiddenFieldText}
          />
        </div>
      );
    });
  };

  render() {
    let { lessonDocumentAttachment } = this.props;
    let { show } = this.state;
    let length = lessonDocumentAttachment.length;
    let faIcon = show ? "fa fa-caret-right" : "fa fa-caret-down";

    return (
      <div className="form-group row">
        <div className="col-md-12">
          <label
            onClick={this.handleShowHide}
            className="control-label-top pointer"
            style={{ fontWeight: 500 }}
          >
            <i className={`pointer ${faIcon}`} aria-hidden="true"></i>
            &ensp;
            {LocaleStrings.course_lesson_attachment_form_label_content_document}
          </label>
        </div>

        {show ? (
          <div className="col-md-12">
            <div className="pl-12">
              <DocumentFilesDrop
                width={350}
                height="auto"
                onFileSave={this.onFilesDrop.bind(this, 0)}
                filepath=""
                onFileChnageLocally={this.onFileAvailable}
                fileName=""
                fileOld=""
                className="lesson-document-dropbox"
              />

              {length === 1 &&
              lessonDocumentAttachment[0].file === "" &&
              lessonDocumentAttachment[0].filename === "" ? (
                ""
              ) : (
                <div className="pt-20">{this.renderAttachment()}</div>
              )}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

class ContentVideo extends BaseComponent {
  constructor(props) {
    super(props);
  }

  onFilesDrop = (index, files) => {
    let { lessonVideoAttachment } = this.props;
    let atthArray = lessonVideoAttachment;

    atthArray[index].file = files.file ? files.file : "";
    atthArray[index].filename = files.filename ? files.filename : "";

    this.props.videoAttachmentData(atthArray);
    this.props.autofill(`content_video[${index}]`, files);
  };

  onFileAvailable = (available) => {};

  handleAttachmentArray = (action, index) => {
    let { lessonVideoAttachment } = this.props;
    let atthArray = lessonVideoAttachment;

    if (action === "add") {
      var obj = {
        key: "video",
        fixed: false,
        file: "",
        filename: "",
        thumbnail: "",
        field: "new",
        attid: "",
      };
      atthArray.push(obj);
    } else {
      _.pullAt(atthArray, index);
      this.props.autofill(`content_video[${index}]`, "");
    }

    this.props.videoAttachmentData(atthArray);
  };

  renderAttachment = () => {
    let { lessonVideoAttachment } = this.props;
    let attachmentArray = lessonVideoAttachment;
    var existingAttachmentsCount = attachmentArray.length;
    let accept = "video/*";

    return _.map(attachmentArray, (item, index) => {
      var filePreview = "";
      var fileName = "";
      var fileOld = true;

      if (item && item.file) {
        var file = item.file;
        fileName = item.filename;
        filePreview = `${BASE_IMAGES_URL}/${file}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
        fileOld = true;
        var n = file.search(";base64,");
        if (n > 0) {
          fileOld = false;
          filePreview = file;
        }
      }

      return (
        <div key={`key-${index}`}>
          <div className="col-md-10">
            <VideoFilesDrop
              width={200}
              height={200}
              onFileSave={this.onFilesDrop.bind(this, index)}
              onFileChnageLocally={this.onFileAvailable}
              filepath={filePreview}
              fileName={fileName}
              fileOld={fileOld}
              className="drop-zone-area"
            />
            <Field
              name={`content_video[${index}]`}
              label=""
              placeholder=""
              type="text"
              component={this.renderHiddenFieldText}
            />
          </div>
          <div className="col-md-2">
            {index === 0 ? (
              <button
                type="button"
                className="btn btn-success"
                onClick={() =>
                  this.handleAttachmentArray("add", existingAttachmentsCount)
                }
              >
                <i className="fa fa-plus-circle"></i>
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => this.handleAttachmentArray("remove", index)}
              >
                <i className="fa fa-minus-circle"></i>
              </button>
            )}
          </div>
        </div>
      );
    });
  };

  render() {
    return (
      <div className="row" style={scrollStyle}>
        <label className="control-label-top col-md-12">
          {LocaleStrings.course_lesson_attachment_form_label_content_video}
        </label>

        {this.renderAttachment()}
      </div>
    );
  }
}

class ContentAudio extends BaseComponent {
  constructor(props) {
    super(props);
  }

  onFilesDrop = (index, files) => {
    let { lessonAudioAttachment } = this.props;
    let atthArray = lessonAudioAttachment;

    atthArray[index].file = files.file ? files.file : "";
    atthArray[index].filename = files.filename ? files.filename : "";

    this.props.audioAttachmentData(atthArray);
    this.props.autofill(`content_audio[${index}]`, files);
  };

  onFileAvailable = (available) => {};

  handleAttachmentArray = (action, index) => {
    let { lessonAudioAttachment } = this.props;
    let atthArray = lessonAudioAttachment;

    if (action === "add") {
      var obj = {
        key: "audio",
        fixed: false,
        file: "",
        filename: "",
        field: "new",
        attid: "",
      };
      atthArray.push(obj);
    } else {
      _.pullAt(atthArray, index);
      this.props.autofill(`content_audio[${index}]`, "");
    }

    this.props.audioAttachmentData(atthArray);
  };

  renderAttachment = () => {
    let { lessonAudioAttachment } = this.props;
    let attachmentArray = lessonAudioAttachment;

    return _.map(attachmentArray, (item, index) => {
      var filePreview = "";
      var fileName = "";
      var fileOld = true;

      if (item && item.file) {
        var file = item.file;
        fileName = item.filename;
        filePreview = `${BASE_IMAGES_URL}/${file}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
        fileOld = true;
        var n = file.search(";base64,");
        if (n > 0) {
          fileOld = false;
        }
      }

      return (
        <AudioFilesDrop
          key={`key-${index}`}
          onFileSave={this.onFilesDrop.bind(this, index)}
          onFileChnageLocally={this.onFileAvailable}
          filepath={filePreview}
          fileName={fileName}
          fileOld={fileOld}
          className="lesson-audio-dropbox"
        />
      );
    });
  };

  render() {
    return (
      <div className="row form-group">
        <div className="col-md-12">
          <label className="control-label-top">
            {LocaleStrings.course_lesson_form_label_lesson_cover_audio}
          </label>

          {this.renderAttachment()}
        </div>
      </div>
    );
  }
}

class ContentLinks extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { show: false };
  }

  renderCustomFieldText(field) {
    return (
      <input
        className="form-control"
        type={field.type}
        placeholder={field.placeholder}
        {...field.input}
        maxLength={field.maxlength ? field.maxlength : ""}
      />
    );
  }

  handleTextChanges = (index, e) => {
    let value = e.target.value;

    let { lessonLinkAttachment } = this.props;
    let atthArray = lessonLinkAttachment;

    atthArray[index].value = value;

    this.props.linkAttachmentData(atthArray);
    // this.props.autofill(`content_link[${index}]`, value);
  };

  handleAttachmentArray = (action, index) => {
    let { lessonLinkAttachment } = this.props;
    let atthArray = lessonLinkAttachment;

    if (action === "add") {
      var obj = {
        key: "link",
        fixed: false,
        value: "",
        field: "new",
        attid: "",
      };
      atthArray.push(obj);
    } else {
      _.pullAt(atthArray, index);
      this.props.autofill(`content_link[${index}]`, "");
    }

    this.props.linkAttachmentData(atthArray);
  };

  handleShowHide = () => {
    this.setState({ show: !this.state.show });
  };

  renderAttachment = () => {
    let { lessonLinkAttachment } = this.props;
    let attachmentArray = lessonLinkAttachment;

    return _.map(attachmentArray, (item, index) => {
      return (
        <div key={`key-${index}`} className="mb-10 lesson-url-atta-delete">
          <Field
            name={`content_link[${index}]`}
            placeholder={
              LocaleStrings.course_lesson_attachment_form_ph_content_link
            }
            type="text"
            component={this.renderCustomFieldText}
            onChange={this.handleTextChanges.bind(this, index)}
          />

          {index === 0 ? (
            ""
          ) : (
            <img
              onClick={() => this.handleAttachmentArray("remove", index)}
              className="url-link-delete-button"
              src="../../style/images/trash_icon_xs.png"
              alt=""
            />
          )}
        </div>
      );
    });
  };

  render() {
    let { lessonLinkAttachment } = this.props;
    let { show } = this.state;
    let attachmentArray = lessonLinkAttachment;
    var existingAttachmentsCount = attachmentArray.length;
    let faIcon = show ? "fa fa-caret-right" : "fa fa-caret-down";

    return (
      <div className="form-group row">
        <div className="col-md-12">
          <label
            onClick={this.handleShowHide}
            className="control-label-top pointer"
            style={{ fontWeight: 500 }}
          >
            <i className={`pointer ${faIcon}`} aria-hidden="true"></i>
            &ensp;
            {LocaleStrings.course_lesson_attachment_form_label_content_link}
          </label>
        </div>

        {show ? (
          <div className="col-md-12">
            <div className="pl-12">{this.renderAttachment()}</div>
          </div>
        ) : (
          ""
        )}

        {show ? (
          <div className="col-md-12 text-right">
            <Button
              type="button"
              className="btn-custom-blue"
              onClick={() =>
                this.handleAttachmentArray("add", existingAttachmentsCount)
              }
            >
              {LocaleStrings.button_add_another}
            </Button>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

class ContentQuiz extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { show: false };
  }

  handleShowHide = () => {
    this.setState({ show: !this.state.show });
  };

  renderAutoComplete(field) {
    return (
      <>
        <Select
          {...field.input}
          className="react-multi-select-custom-css"
          isMulti={field.isMulti ? true : false}
          value={field.input.value || ""}
          valueKey={field.valueKey}
          placeholder={field.placeholder}
          labelKey={field.labelKey}
          options={field.options}
          onBlur={() => field.input.onBlur(field.input.value)}
          isClearable
        />
      </>
    );
  }

  render() {
    let { quizList } = this.props;
    let { show } = this.state;
    let faIcon = show ? "fa fa-caret-right" : "fa fa-caret-down";
    let quiz = [];

    if (quizList && quizList.data) {
      _.map(quizList.data, (item, index) => {
        let obj = {
          name: `${item.formname} (${item.formnumber})`,
          value: item.formid.toString(),
        };

        quiz.push(obj);
      });
    }

    return (
      <div className="form-group row">
        <div className="col-md-12">
          <label
            onClick={this.handleShowHide}
            className="control-label-top pointer"
            style={{ fontWeight: 500 }}
          >
            <i className={`pointer ${faIcon}`} aria-hidden="true"></i>
            &ensp;
            {LocaleStrings.course_lesson_form_label_quiz}
          </label>
        </div>

        {show ? (
          <div className="col-md-12">
            <div className="pl-12">
              <Field
                name="quizid"
                placeholder={LocaleStrings.course_lesson_form_ph_quiz}
                component={this.renderAutoComplete}
                mandatory="false"
                options={quiz}
                labelKey="name"
                valueKey="value"
                value={{}}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

class LessonSettingsForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { show: false };
  }

  handleShowHide = () => {
    this.setState({ show: !this.state.show });
  };

  render() {
    let { show } = this.state;
    let faIcon = show ? "fa fa-caret-right" : "fa fa-caret-down";

    return (
      <div>
        <div className="form-group row">
          <div className="col-md-12">
            <label
              onClick={this.handleShowHide}
              className="control-label-top pointer"
              style={{ fontWeight: 500 }}
            >
              <i className={`pointer ${faIcon}`} aria-hidden="true"></i>
              &ensp;
              {LocaleStrings.course_lesson_form_text_lesson_setting}
            </label>
          </div>

          {show ? (
            <div className="col-md-12">
              <div className="pl-12">
                <Field
                  name="ispreview"
                  label={
                    LocaleStrings.course_lesson_form_label_lesson_preview_lesson
                  }
                  component={this.renderFieldCheckbox}
                  type="checkbox"
                />
                <Field
                  name="ismandatory"
                  label={
                    LocaleStrings.course_lesson_form_label_lesson_mandatory_lesson
                  }
                  component={this.renderFieldCheckbox}
                  type="checkbox"
                />
                <Field
                  name="isqabased"
                  label={
                    LocaleStrings.course_lesson_form_label_lesson_qa_based_lesson
                  }
                  component={this.renderFieldCheckbox}
                  type="checkbox"
                />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
